import { useNavigate } from "react-router-dom";
import Button from "../../components/common/Button";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import ResetPasswordForm from "../../components/Admin/ResetPasswordForm";

const ResetPassword = () => {
  const navigate = useNavigate();
  const showDistrict = history.state?.usr?.showDistrict || false;
  return (
    <DashboardLayout pageTitle="Profile" mainClass="p-6">
      <div className="flex justify-end mb-4">
        <Button
          className="bg-btn font-semibold py-2 px-4 rounded-md"
          onClick={() =>
            navigate(
              showDistrict
                ? "/admin/district-officers"
                : "/admin/state-officers"
            )
          }
        >
          Back
        </Button>
      </div>
      <div className="flex h-12 nav-bg p-3 text-white font-semibold rounded-tr rounded-tl">
        Change Password
      </div>
      <div className="bg-white p-6 rounded-b shadow-md mx-auto">
        <ResetPasswordForm />
      </div>
    </DashboardLayout>
  );
};

export default ResetPassword;
